import React from "react";
import Layout from "../components/Layout";
import MeetPost from "../components/Employé/MeetPost";

function MeetPosts() {
  
  return (
    <Layout >
      <div className="p-6">
        <MeetPost />
      </div>
    </Layout>
  );
}

export default MeetPosts;
